import React from "react";
import { Loader } from "lucide-react";
import { useCategory } from "./CategoryPublisherList";
import { useNavigate } from "react-router-dom";

export const GenerateDigestButton = ({ onClick, isLoading }) => {
  const navigate = useNavigate();
  const { categories, enabledItems } = useCategory();

  const hasEnabledItems = Object.keys(enabledItems).reduce((acc, category) => {
    const selections = enabledItems[category]
    if (acc) return acc
    Object.values(selections).forEach(selection => {
      if (selection) acc = true
    })
    return acc
  }, false)

  const handleClick = () => {
    onClick && onClick()
  }

  return (
    <div className="m-4">
      <button
        className={`w-full py-2 px-3 text-sm font-semibold tracking-wider border rounded-md transition-colors duration-200 flex items-center justify-center
          ${hasEnabledItems ? "text-white border-primary bg-primary hover:bg-primary-dark"
            : "text-gray-400 border-gray-300 bg-gray-50 cursor-not-allowed"
          }
        `}
        onClick={handleClick}
        disabled={!isLoading && !hasEnabledItems}
      >
        {isLoading ? (
          <Loader className="animate-spin mr-2" size={16} />
        ) : null}
        {isLoading ? (categories.length === 0) ? "Loading..." : "Generating..." : "Generate Summary"}
      </button>
    </div>
  )
}

export default GenerateDigestButton;
